"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author mariam.melkonyan
 * @since 2/16/17.
 */
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var notification_status_1 = require("../shared/utilities/notification-status");
var form_component_1 = require("./form.component");
var Subject_1 = require("rxjs/Subject");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var of_1 = require("rxjs/observable/of");
var from_1 = require("rxjs/observable/from");
var empty_1 = require("rxjs/observable/empty");
var throw_1 = require("rxjs/observable/throw");
var noop_1 = require("rxjs/util/noop");
var EditFormComponent = /** @class */ (function (_super) {
    __extends(EditFormComponent, _super);
    function EditFormComponent(_deService, _classifierService, _kbService, _languageService, _currentLanguageProvider, _lockingService) {
        var _this = _super.call(this, _deService, _classifierService, _kbService, _languageService, _currentLanguageProvider) || this;
        _this._deService = _deService;
        _this._classifierService = _classifierService;
        _this._kbService = _kbService;
        _this._languageService = _languageService;
        _this._currentLanguageProvider = _currentLanguageProvider;
        _this._lockingService = _lockingService;
        /**
         * "EntityName" field systemName, which is showing in monitoring screen.
         * In KB configs the type of this systemName field must be string.
         * @type {string}
         */
        // tslint:disable-next-line:no-null-keyword
        _this._lockField = null;
        _this.destroySubject$ = new Subject_1.Subject();
        _this._entityComparisonHelper = new idm_de_core_frontend_1.EntityComparisonHelper(_this._kbService);
        return _this;
    }
    EditFormComponent.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    /**
     * Loads and Initializes MainEntity
     * @param {number} instanceId
     */
    EditFormComponent.prototype.loadEditFormData = function (instanceId) {
        var _this = this;
        var mainEntity$;
        if (isNaN(instanceId)) {
            mainEntity$ = this._deService
                .createBlankEntity(this._systemName)
                .pipe(operators_1.first(), operators_1.switchMap(function (value) {
                _this._mainEntity = value;
                return _this.onMainEntityLoaded();
            }));
        }
        else {
            mainEntity$ = this.loadMainEntity(instanceId).pipe(operators_1.first());
        }
        var languages$ = this._languageService.getInputLanguages();
        var currentLanguage$ = this._currentLanguageProvider.getCurrentLanguage();
        combineLatest_1.combineLatest(mainEntity$, languages$, currentLanguage$)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            var languages = data[1];
            var language = data[2];
            _this._languages = languages;
            _this._currentLanguageId = language.getId();
            _this.isReady = true;
        }, function (err) { return console.error(err); });
    };
    /**
     * Remove mainEntity lock and navigate to view page.
     * This function also calls when window close/unload.
     */
    EditFormComponent.prototype.unlock = function () {
        var _this = this;
        this._lockingService
            .removeLock(this._systemName, this._mainEntity.getInstanceId())
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            _this.navigateToViewPage();
        }, function (err) { return console.error(err); });
    };
    /**
     * Remove mainEntity lock.
     */
    EditFormComponent.prototype.removeLock = function () {
        if (this._mainEntity.getId() !== null && this._mainEntity.getId() > 0) {
            this._lockingService
                .removeLock(this._systemName, this._mainEntity.getInstanceId())
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (data) {
                console.warn('Lock removed.');
            }, function (err) { return console.error(err); });
        }
    };
    /**
     * Add lock for mainEntity.
     */
    EditFormComponent.prototype.addLock = function () {
        this._lockingService
            .addLock(this._systemName, this._mainEntity.getInstanceId(), this._mainEntity.getProperty(this._lockField).value)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(undefined, function (err) { return console.log(err); });
    };
    EditFormComponent.prototype.onCancel = function () {
        if (this._mainEntity.getId() !== null && this._mainEntity.getId() > 0) {
            this.unlock();
        }
    };
    /**
     * Saves after comparing old data with modified data.
     */
    EditFormComponent.prototype.onSave = function () {
        var _this = this;
        var areEqual$ = this.compareEntities();
        areEqual$
            .pipe(operators_1.switchMap(function (areEqual) {
            if (!areEqual) {
                console.log('Saving...');
                return _this.save();
            }
            else {
                _this._validations = [];
                _this._notificationStatus.next(notification_status_1.NotificationStatus.NO_MODIFICATION);
                return empty_1.empty();
            }
        }), operators_1.map(function (serviceResponse) {
            _this.processServiceResponse(serviceResponse);
            if (_this._validations.length === 0) {
                _this.onSaveDone();
            }
        }), operators_1.catchError(function (err) {
            console.error(err);
            return empty_1.empty();
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(noop_1.noop, console.error);
    };
    /**
     * After Save done preparation
     */
    EditFormComponent.prototype.onSaveDone = function () {
        this.addLock();
        this._oldMainEntity = this.mainEntity.clone();
    };
    /**
     * Saves after comparing old data with modified data.
     */
    EditFormComponent.prototype.onSaveAndClose = function () {
        var _this = this;
        var areEqual = this.compareEntities();
        areEqual
            .pipe(operators_1.switchMap(function (areEqual) {
            if (!areEqual) {
                return _this.save();
            }
            else {
                _this._validations = [];
                _this._notificationStatus.next(notification_status_1.NotificationStatus.NO_MODIFICATION);
                _this.unlock();
                return empty_1.empty();
            }
        }), operators_1.map(function (serviceResponse) {
            _this.processServiceResponse(serviceResponse);
            if (_this._validations.length === 0) {
                _this.onSaveAndCloseDone();
            }
        }), operators_1.catchError(function (err) {
            console.error(err);
            return empty_1.empty();
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(noop_1.noop, console.error);
    };
    /**
     * After Save and Close done preparation
     */
    EditFormComponent.prototype.onSaveAndCloseDone = function () {
        this.unlock();
    };
    /**
     * Creates new mainEntity model or updates the existing one.
     * @returns {Observable<any>}
     */
    EditFormComponent.prototype.save = function () {
        var _this = this;
        if (!!this._mainEntity.getId() && this._mainEntity.getId() !== -1) {
            return this.onBeforeSave().pipe(operators_1.switchMap(function (mainEntity) {
                return _this._deService
                    .update(_this._systemName, _this._mainEntity)
                    .pipe(operators_1.catchError(_this.handelErrorResponses));
            }));
        }
        else {
            return this.onBeforeSave().pipe(operators_1.switchMap(function (mainEntity) {
                return _this._deService.add(_this._systemName, _this._mainEntity);
            }));
        }
    };
    /**
     * Preparation of Before Save logic
     * @returns {Observable<any>}
     */
    EditFormComponent.prototype.onBeforeSave = function () {
        return of_1.of(null);
    };
    /**
     * Compares old and current entities.
     * @returns {Observable<boolean>}
     */
    EditFormComponent.prototype.compareEntities = function () {
        if (this._oldMainEntity !== undefined && this._oldMainEntity !== null) {
            return from_1.from(this._entityComparisonHelper.equals(this._systemName, this._mainEntity, this._oldMainEntity));
        }
        else {
            return of_1.of(false);
        }
    };
    /**
     * * Preparation logic after workflow existence checking
     * @returns {Observable<any>}
     */
    EditFormComponent.prototype.onWorkflowExistenceLoaded = function () {
        return of_1.of(null);
    };
    /**
     * Sets the selected value from component (combo, radio) to mainEntity's property
     * @param {any} event
     * @param {string} systemName - Category name of the classifier.
     * @param {string} classifierKey - Classifier key of the household.
     */
    EditFormComponent.prototype.onClassifierChanged = function (event, systemName, classifierKey) {
        var selectedClassifierId = +event.target.value;
        this._mainEntity.getProperty(systemName).value = !selectedClassifierId
            ? null
            : this.getClassifierById(selectedClassifierId, classifierKey);
    };
    /**
     * Processes Response from Service after MainEntity Save
     * @param {ServiceResponse<MainEntity>} serviceResponse
     */
    EditFormComponent.prototype.processServiceResponse = function (serviceResponse) {
        var validations = serviceResponse
            .getMeta()
            .getValidations();
        this._mainEntity = serviceResponse.getData();
        if (validations.length > 0) {
            this._validations = validations;
            this._notificationStatus.next(notification_status_1.NotificationStatus.FAILURE);
        }
        else {
            this._validations = [];
            this._notificationStatus.next(notification_status_1.NotificationStatus.SUCCESS);
            console.log('Saved with ID : ' + this._mainEntity.getId());
        }
    };
    EditFormComponent.prototype.handelErrorResponses = function (err) {
        switch (err.status) {
            case 404: {
                this._notificationStatus.next(notification_status_1.NotificationStatus.ENTITY_NOT_FOUND);
                break;
            }
            case 423: {
                this._notificationStatus.next(notification_status_1.NotificationStatus.ENTITY_LOCKED);
                break;
            }
            case 502: {
                this._notificationStatus.next(notification_status_1.NotificationStatus.SERVICE_UNAVAILABLE);
                break;
            }
        }
        return throw_1._throw(err);
    };
    __decorate([
        core_1.HostListener('window:popstate'),
        core_1.HostListener('window:beforeunload'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EditFormComponent.prototype, "removeLock", null);
    return EditFormComponent;
}(form_component_1.FormComponent));
exports.EditFormComponent = EditFormComponent;
//# sourceMappingURL=edit-form.component.js.map